<template>
  <a
    class="main-item-wrapper d-flex flex-column position-relative"
    v-if="!mobile"
    @click="goTo(link)"
  >
    <div class="item_img cursor-pointer">
      <img :src="image" @error="imageLoadError($event)" />
      <div class="latest-tag" v-if="latestTag">
        <span class="latest-text">NEW</span>
      </div>
    </div>
    <div class="background-overlay"></div>
    <div class="main-details-div d-flex flex-column justify-content-start">
      <p class="idx-number mb-1 mb-md-2">{{ index + 1 }}</p>
      <div class="titleDiv" v-if="title">
        <p class="mb-0 title_text text-left mt-2">
          {{ truncateString(title, 20) }}
        </p>
      </div>
    </div>
    <div class="overlay">
      <div class="w-100 d-flex flex-column justify-content-between">
        <div class="w-100 d-flex flex-column">
          <div v-if="title" class="mb-1">
            <p class="mb-0 title_text_overlay text-left">{{ title }}</p>
          </div>
          <div
            class="d-flex justify-content-start mb-1"
            v-if="classificationLabel"
          >
            <p class="classificationLabel mb-0">
              {{ classificationLabel }}
            </p>
          </div>
          <div class="d-flex justify-content-start" v-if="categoriesLabel">
            <p class="categoryLabel mb-0 long-title text-left">
              {{ categoriesLabel }}
            </p>
          </div>
        </div>

        <div
          class="w-100 d-flex justify-content-start align-items-center flex-row mt-3"
        >
          <div class="icon cursor-pointer" @click="goTo(link)">
            <img src="../../../assets/rtmklik/main-play.svg" alt="play icon" />
          </div>
          <p class="d-none d-lg-block mb-0 label">
            Tonton Sekarang
          </p>
          <!-- <div class="icon cursor-pointer" @click="addToFavorite(itemID)">
            <img src="../../../assets/rtmklik/main-like.svg" alt="play icon" />
          </div>
          <div class="icon cursor-pointer">
            <img src="../../../assets/rtmklik/main-share.svg" alt="play icon" />
          </div> -->
        </div>
      </div>
    </div>
    <!-- <div class="titleDiv" v-if="title">
      <p class="mb-0 title_text text-left mt-2">{{ title }}</p>
    </div> -->

    <!-- <div class="overlay">
      <div class="w-100 d-flex flex-column justify-content-between">
        <div class="w-100 d-flex justify-content-between align-items-center">
          <div class="">
            <div v-if="title" class="mb-1">
              <p class="mb-0 title_text_overlay text-left">
                {{ title }}
              </p>
            </div>
            <div
              class="d-flex justify-content-start mb-1"
              v-if="classificationLabel"
            >
              <p class="classificationLabel mb-0">
                {{ classificationLabel }}
              </p>
            </div>
            <div class="d-flex justify-content-start" v-if="categoriesLabel">
              <p class="categoryLabel mb-0 long-title text-left">
                {{ categoriesLabel }}
              </p>
            </div>
          </div>
          <div class="d-flex justify-content-start flex-row">
            <div class="icon cursor-pointer" @click="goTo(link)">
              <img
                src="../../../assets/rtmklik/main-play.svg"
                alt="play icon"
              />
            </div>-->
    <!-- <div class="icon cursor-pointer">
              <img
                src="../../../assets/rtmklik/main-like.svg"
                alt="play icon"
              />
            </div>
            <div class="icon cursor-pointer">
              <img
                src="../../../assets/rtmklik/main-share.svg"
                alt="play icon"
              />
            </div> -->
    <!-- </div>
        </div>
      </div>
    </div> -->
  </a>
  <router-link
    :to="link"
    class="main-item-wrapper d-flex flex-column position-relative"
    v-else
  >
    <div
      class="item_img"
      v-lazy-container="{
        selector: 'img',
        error: require('../../../assets/noimage.png'),
        loading: require('../../../assets/loading.gif'),
      }"
    >
      <img :data-src="image" @error="imageLoadError($event)" />
    </div>
    <div class="background-overlay"></div>
    <div class="main-details-div d-flex flex-column justify-content-start">
      <p class="idx-number mb-1 mb-md-2">{{ index + 1 }}</p>
      <div class="title">
        <p class="mb-0 title_text text-left mt-2">
          {{ truncateString(title, 20) }}
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
/* eslint-disable */
import noimage from "../../../assets/noimage.png";
export default {
  name: "vod-card-comp",
  props: [
    "image",
    "latestTag",
    "title",
    "description",
    "link",
    "category",
    "data",
    "index",
  ],
  data: function() {
    return {
      mobile: false,
      window: {
        width: 0,
      },
      overlayData: this.data,
      classificationLabel: "",
      categoriesLabel: "",
      firstEpisodeLabel: "",
    };
  },
  methods: {
    imageLoadError(event) {
      event.target.src = noimage;
    },
    goTo(link) {
      this.$router.push(link);
    },

    truncateString(str, num) {
      if (str.length > num) {
        return str.slice(0, num) + "...";
      } else {
        return str;
      }
    },
    handleResizeforCard() {
      this.window.width = window.innerWidth;

      if (this.window.width >= 992) {
        this.mobile = false;
      } else {
        this.mobile = true;
      }
    },
    initData() {
      const classificationFirst =
        this.overlayData &&
        this.overlayData.classification &&
        this.overlayData.classification.title &&
        this.overlayData.classification.title.en_US;

      this.classificationLabel = classificationFirst ? classificationFirst : "";

      // getCategories
      const categoriesFirst =
        this.overlayData &&
        this.overlayData.categories[0] &&
        this.overlayData.categories[0].title &&
        this.overlayData.categories[0].title.en_US;

      this.categoriesLabel = categoriesFirst ? categoriesFirst : "";
    },
  },
  created() {
    window.addEventListener("resize", this.handleResizeforCard);
    this.handleResizeforCard();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResizeforCard);
  },
  mounted() {
    this.initData();
  },
};
</script>

<style scoped>
.main-item-wrapper {
  z-index: 1;
  height: 100%;
  text-decoration: none;
  height: 100%;
}

.item_img {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  padding-top: calc(300 / 220 * 100%);
  z-index: 1;
}
.item_img img {
  background: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
  z-index: 2;
}
.background-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
  height: 60%;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.8) 86.08%
  );
  width: 100%;
}
.label {
  color: #fff;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
}
.main-details-div {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 3;
  padding: 0 0 16px 8px;
}
.main-item-wrapper .overlay {
  display: none;
}

@media only screen and (min-width: 992px) {
  /* .main-item-wrapper:hover .titleDiv {
    display: none;
  }
  .main-item-wrapper:hover .main-details-div {
    display: none !important;
  } */
  /* .main-item-wrapper:hover .item_img {
    height: 100%;
    padding-top: 61%;
  } */
  /* .main-item-wrapper:hover .overlay {
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 14;
    width: 100%;
  } */
  .main-item-wrapper:hover {
    transform: scale(1.01);
  }
  .main-item-wrapper:hover .titleDiv {
    display: none;
  }
  .main-item-wrapper:hover .item_img {
    padding-top: calc(349 / 270 * 100%);
    border-radius: 8px 8px 0 0;
  }
  .main-item-wrapper:hover .overlay {
    display: block;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 14;
    width: 100%;
  }
  .main-item-wrapper:hover .overlay {
    display: block;
    position: absolute;
    top: 99%;
    left: 0;
    z-index: 14;
    width: 100%;
  }
}
.tags-wrapper {
  width: 45px;
  padding: 2px 4px;
  height: 20px;
  position: absolute;
  right: 0;
  top: 8px;
  background-color: #f00;
  z-index: 4;
}
.tags-text {
  font-size: 12px;
  font-family: "HelveticaNeue-Bold";
  font-weight: bold;
  line-height: 1.25;
  text-align: left;
  color: #fff;
  z-index: 4;
}

.title_text {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
}
.idx-number {
  text-align: center;
  font-family: "Mont-Bold";
  font-size: 80px;
  font-style: normal;
  font-weight: 900;
  line-height: 50%;
  text-align: left;
  color: rgba(0, 0, 0, 0);
  -webkit-text-stroke: 2px #d9e021; /* width and color */
}
.classificationLabel {
  color: #fff;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
}
.categoryLabel {
  color: #fff;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.icon {
  width: 32px;
  height: 32px;
  margin-right: 8px;
}
.icon img {
  width: 100%;
  height: 100%;
}
/* .overlay {
  padding: 8px 16px 16px;
  border-radius: 0 0 8px 8px;
  min-height: 120px;
} */
.overlay {
  background: #171f26;
  padding: 12px 16px;
  border-radius: 0 0 8px 8px;
}
.title_text_overlay {
  color: #fff;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media only screen and (max-width: 992px) {
  .item_img {
    filter: saturate(100%);
  }
}
@media only screen and (max-width: 768px) {
  .idx-number {
    font-size: 60px;
  }
  .title_text {
    font-size: 12px;
  }
}
</style>
<style>
@media only screen and (max-width: 480px) {
}
</style>
